"use client";

import { useSyncExternalStore } from "react";
import { useSearchParams, type ReadonlyURLSearchParams } from "next/navigation";

const EMPTY = new URLSearchParams() as unknown as ReadonlyURLSearchParams;
const noopSubscribe = () => () => {};

/**
 * useSearchParams for routes served from the static cache (app/[slug] is
 * force-static): their HTML is rendered with no query string, so the first
 * client render must see none either or ?country= links fail to hydrate. The
 * real params arrive one render later; client navigations see them at once.
 * `staticRoute: false` (a shared component on a dynamic route) is plain useSearchParams.
 */
export function useHydratedSearchParams(staticRoute = true): ReadonlyURLSearchParams {
  const params = useSearchParams();
  const hydrated = useSyncExternalStore(noopSubscribe, () => true, () => false);
  return hydrated || !staticRoute ? params : EMPTY;
}
